import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import '../App.css';
import logo from '../img/logo.png'

import Scroll from 'react-scroll'
// import { click } from '@testing-library/user-event/dist/click';
const ScrollLink = Scroll.Link



function Header() {
    const [exp, setExp] = useState();
    const expand=()=>{
        if(exp==="act"){
            setExp("reverse")
        }
        else{
            setExp("act")
        }
    }
    const style1 = {
        fontSize: "36px",
    }
    return (


        <header id="Header">
            <nav className="navbar">
                <ul>
                    <li className="navbar-logo" style={{padding :"5px"}}><img style={{height :"80px", width:"120px"}} src={logo} alt=''></img></li>
                    <li id="menu" className="navbar-toggle">
                        <i className="fa fa-bars" style={style1} onClick={expand}></i>
                    </li>
                    <li className={`navbar-links ${exp}`}><Link to='\'>Home</Link></li>
                    <li className={`navbar-links ${exp}`}><ScrollLink to="section2" smooth={true} duration={500} >About</ScrollLink></li>
                    <li className={`navbar-links ${exp}`}><ScrollLink to="section3" smooth={true} duration={500} >Contact</ScrollLink></li>
                    <li className={`navbar-links ${exp}`}><ScrollLink to="section1" smooth={true} duration={500} >Services</ScrollLink></li>
                </ul>
            </nav>
            <hr style={{ opacity: "0.5" }} />
        </header>
    )
}

export default Header
